import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; // Import de Framer Motion
import '../Style/Accueil.css';

function Accueil() {
  return (
    <motion.div 
      className="container"
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      transition={{ duration: 1 }}
    >
      {/* Section Hero */}
      <motion.header 
        className="hero"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h1 className="hero-title">
          Bienvenue sur <span>Pâtichmie</span> !
        </h1>
        <p className="hero-subtitle">
          La science des saveurs et des molécules au service de la pâtisserie.
        </p>
      </motion.header>

      {/* Boutons d'actions */}
      <motion.section 
        className="actions"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
      >
        <Link to="/recettes">
          <motion.button 
            className="btn btn-recipes"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Voir les Recettes
          </motion.button>
        </Link>
        <Link to="/science">
          <motion.button 
            className="btn btn-science"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Explorer la Science
          </motion.button>
        </Link>
      </motion.section>

      {/* Introduction */}
      <motion.section 
        className="introduction"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 0.7 }}
      >
        <h2>Un univers sucré et scientifique</h2>
        <p>
          Apprenez comment les ingrédients de vos desserts préférés interagissent au niveau moléculaire pour créer des chefs-d'œuvre de goût.
        </p>
      </motion.section>
    </motion.div>
  );
}

export default Accueil;
